import { useSelector } from 'react-redux';
import { selectUserAttributes } from '@features/auth/slice';

export function useIsMerchantParent(): boolean {
  const attrs = useSelector(selectUserAttributes);
  const isMerchant = attrs.entity?.some((v) => v?.toLowerCase() === 'merchant');
  const isParent = attrs.type?.some((t) => t?.toLowerCase() === 'parent');
  return Boolean(isMerchant && isParent);
}
